import React from 'react';

const Card = ({ image, title, desc, outerClass, imageClass, link }) => {
  return (
    <button className="md:basis-1/2 md:p-4 relative group">
      <a href={link} target="_blank">
        <div className={`pt-4 px-1 w-full flex justify-center rounded-md ${outerClass}`}>
          <img src={image} alt="" className={`${imageClass} w-80 md:w-96 lg:w-[500px] xl:w-[700px] 2xl:w-[800px]`} />
        </div>
        <div className="text-lg tracking-widest uppercase text-slate-700 mt-3 font-semibold lg:text-2xl">{title}</div>
        <p className="tracking-wider font-light text-slate-700 text-sm lg:text-base">{desc}</p>
        <div className={`absolute top-0 right-0 bottom-0 left-0 ${outerClass} md:m-4 rounded-md transition-opacity duration-500 opacity-0 group-hover:opacity-20`} />
      </a>
    </button>
  );
};

export default Card;
